// ** Arrow Icons Data

export const arrowIcons = {
	"arrow-alt-to-bottom": {
		viewBox: "0 0 384 512",
		variants: {
			solid: {
				"data-prefix": "fas",
				"data-icon": "arrow-alt-to-bottom",
				source: "https://fontawesome.com/icons/arrow-alt-to-bottom",
				license: "https://fontawesome.com/license",
				path: "M360 480H24c-13.3 0-24-10.7-24-24v-24c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24v24c0 13.3-10.7 24-24 24zM128 56v136H40.3c-17.8 0-26.7 21.5-14.1 34.1l152.2 152.2c7.5 7.5 19.8 7.5 27.3 0l152.2-152.2c12.6-12.6 3.7-34.1-14.1-34.1H256V56c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24z",
			},
		},
	},
	"arrow-up": {
		viewBox: "0 0 448 512",
		variants: {
			solid: {
				"data-prefix": "fas",
				"data-icon": "arrow-up",
				source: "https://fontawesome.com/icons/arrow-up",
				license: "https://fontawesome.com/license",
				path: "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z",
			},
		},
	},
};
